import React from "react";
import { HiMiniUser } from "react-icons/hi2";
import { HiMiniInboxStack } from "react-icons/hi2";
import { useInbox } from "../../contexts/inbox";

const InboxHeader = () => {
  const { inbox, selectedGroupId, groups } = useInbox();
  
  // If no inbox is selected but a group is selected, show the "All inboxes" header
  if (!inbox && selectedGroupId) {
    const group = groups?.find(g => g.id === selectedGroupId);
    if (group) {
      return (
        <>
          <div className="flex items-center gap-2">
            <h1 className="text-xl font-bold">
              All inboxes
            </h1>
            <div className="relative inline-block">
              <HiMiniInboxStack className="w-5 h-5 text-gray-600" />
            </div>
          </div>
          <p className="text-gray-600">{group.name} ({group.inboxes?.length || 0} inboxes)</p>
        </>
      );
    }
  }
  
  // If no inbox is selected and no group is selected, return null
  if (!inbox) return null;
  
  // Regular inbox header
  return (
    <>
      <div className="flex items-center gap-2">
        <h1 className="text-xl font-bold">
          {inbox.user && inbox.user.name
            ? inbox.user.name
            : inbox.phoneNumber || inbox.email}
        </h1>
        {inbox.userId && (
          <div className="relative inline-block">
            <HiMiniUser
              className="w-5 h-5 text-gray-600 cursor-pointer"
              onMouseEnter={(e) => {
                const tooltip = document.createElement("div");
                tooltip.id = "user-tooltip";
                tooltip.innerText = inbox.user
                  ? `${inbox.user.name || ""}`.trim()
                  : "Associated User";

                tooltip.className = "absolute bg-black/80 text-white py-1 px-2.5 rounded text-sm z-50 top-full left-1/2 -translate-x-1/2 mt-1 whitespace-nowrap";
                e.currentTarget.parentNode.appendChild(tooltip);
              }}
              onMouseLeave={() => {
                const tooltip = document.getElementById("user-tooltip");
                if (tooltip) tooltip.remove();
              }}
            />
          </div>
        )}
      </div>
      <p className="text-gray-600">Type: {inbox.inboxType}</p>
    </>
  );
};

export default InboxHeader;
